// @flow
import React from 'react'
import i18n from 'i18next'
import { Typography } from '@material-ui/core'

import Link from '../../../Link'
import styles from './styles'

type Props = {
  isAuthenticated: boolean,
  color: string
}

export const AuthStatusDesktop = (props: Props) => (
  props.isAuthenticated
    ? <Link to={i18n.t('routes.ACCOUNT_PERSONAL')} style={styles.login}>
      <Typography variant='subtitle1' style={styles.color(props.color)}>
        {i18n.t('appshell.myAccount')}
      </Typography>
    </Link>
    : <Link to={i18n.t('routes.AUTH')} style={styles.login}>
      <Typography variant='subtitle1' style={styles.color(props.color)}>
        {i18n.t('appshell.login')}
      </Typography>
    </Link>
)

export default AuthStatusDesktop
